module.exports = "/static/assets/edf5571fc769a213bbbac59c1d03340f.png";